import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext } from '../Modal/ModalContext';

interface MoreOptionsCellProps {
  icon: React.ReactNode;
  label: string;
  onClick?: (...args: any) => void;
  hasModal?: boolean;
  color?: string;
  width?: string;
}

const MoreOptionsCell: React.FC<MoreOptionsCellProps> = ({
  icon,
  label,
  onClick,
  hasModal = false,
  color,
  width,
}) => {
  const modalContext = useContext(ModalContext);

  const handleShowModal = () => {
    modalContext?.setShowModal(true);
  };

  return (
    <Container
      width={width}
      color={color}
      onClick={(e) => {
        hasModal && handleShowModal();
        onClick && onClick(e);
      }}
    >
      {icon} {label}
    </Container>
  );
};

export default MoreOptionsCell;

interface IContainer {
  color?: string;
  width?: string;
}

const Container = styled.div<IContainer>`
  display: flex;
  gap: 12px;
  width: ${({ width }) => (width ? width : '343px')};
  font-weight: 500;
  padding: 14px 16px;
  background-color: white;
  font-size: 14px;

  color: ${({ color }) => (color ? color : '#6B7280')};

  &:hover {
    background-color: #f7f7f7;
  }
`;
